// extracted by mini-css-extract-plugin
module.exports = {"layout":"fhs-brand_layout__nl5pS","brand":"fhs-brand_brand__O_scq","sector":"fhs-brand_sector__2_yqq"};